import baseAPI from "@/http";

const router = "api/seloDiagnosticoResposta";

export const seloDiagnosticoRespostaAPI = {
  list: (municipioId, uf, parceiro) =>
    baseAPI.get(
      `${router}/obter-diagnostico-resposta-por-municipio/${municipioId}/${uf}/${parceiro}`
    ),
  atualizar: (resposta) =>
    baseAPI.put(`${router}/atualizar-diagnostico-resposta`, resposta),
  delete: (respostaId, uf, parceiro) =>
    baseAPI.delete(
      `${router}/deletar-resposta?id=${respostaId}&uf=${uf}&parceiro=${parceiro}`
    ),
  enviarAnalise: (municipioId, uf, parceiro) =>
    baseAPI.put(`${router}/setar-enviada/${municipioId}/${uf}/${parceiro}`),
downloadPdf: (municipioId, uf, parceiro) =>
  baseAPI.get(
    `${router}/selo-diagnostico-pdf-by-municipioId/${municipioId}?uf=${uf}&parceiro=${parceiro}`,
    { responseType: "blob" }
  ),
  getRespostaPergunta: (perguntaId, municipioId, uf) =>
    baseAPI.get(
      `${router}/obter-diagnostico-resposta-por-pergunta-municipio/${perguntaId}/${municipioId}?uf=${uf}`
    ),
};
